// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ConfigurarWebhookResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/accounts/configurar_webhook/{id}
 *
 * The controller normalizes the upstream provider's configureWebhook()
 * return value into a fixed 4-field shape before responding, so the wire
 * shape is deterministic regardless of the raw upstream JSON:
 *   - webhook_id  ← $result['id']      (provider webhook identifier)
 *   - webhook_url ← $result['url']     (registered callback URL)
 *   - events      ← $result['events']  (subscribed event names)
 *   - enabled     ← $result['enabled'] (webhook active flag)
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsFranchises_ConfigurarWebhookResponseDados {
events: string[]
enabled: boolean
webhook_id?: string
webhook_url?: string
}

export type SubaccountsFranchises_ConfigurarWebhookResponse = ApiResponse<SubaccountsFranchises_ConfigurarWebhookResponseDados>;

registerResponseContract('SubaccountsFranchises_ConfigurarWebhookResponse', {
  events:      { type: 'array',   required: true },
  enabled:     { type: 'boolean', required: true },
  webhook_id:  { type: 'string',  required: false },
  webhook_url: { type: 'string',  required: false },
})
